import DashboardModel from './model/dashboard.model';
import EVENTS from '@shared/events';
import { parseBoolean } from '../../../shared/utils/bool.utils';
import { BaseController } from '@shared/basecontroller.controller';

class DashboardController extends BaseController {
  constructor(AppService, DashboardStore, PageService, StorageService, EventDispatcherService) {
    'ngInject';

    super(AppService);

    this.AppService = AppService;
    this.DashboardStore = DashboardStore;
    this.PageService = PageService;
    this.StorageService = StorageService;
    this.EventDispatcherService = EventDispatcherService;

    // TODO: Should be in model.
    this.isEnabled = true;
  }

  $doCheck() {
    parent.postMessage('connected', '*');
  }

  $onInit() {
    this.model = new DashboardModel();
    this.session = this.getSession();

    this.updateModel();
    this.checkStatus();

    this.subscription = this.EventDispatcherService.addListener(EVENTS.BET_PROCESSED, event => this.updateModel());
  }

  doNotShowGoogleAuthenticatorPrompt() {
    this.StorageService.setItem('do-not-show-google-prompt', true);
  }

  goToGoogleAuthSettings() {
    this.goToState('settings', {'#': 'google-auth'});
  }

  $onDestroy() {
    this.subscription.remove();
  }

  // TODO: Create a separate component for balance.
  updateModel() {
    return this.DashboardStore.getDashboardDetails().then((details) => {
      this.model.balance.unallocated = details.balance.unallocated;
      this.model.balance.acWalletWithdrawable = details.balance.acWalletWithdrawable;
      //this.model.balance.totalRunningCommission = details.balance.totalRunningCommission;

      this.model.currency = details.others.currency;
      this.model.verifiedAt = details.others.verifiedAt;
      this.model.activatedAt = details.others.activatedAt;
      this.model.status = details.others.verifiedAt ? 'Verified' : 'Not Verified';

      //For now affiliate stats is not yet part of this feature.
      //We will uncomment this once they have decided to use the affiliate stats graph.
      /*this.model.statistics.referralCount = details.statistics.referralCount;
      this.model.statistics.newCustomers = details.statistics.newCustomers;
      this.model.statistics.customersWithDeposit = details.statistics.customersWithDeposit;
      this.model.statistics.activeCustomers = details.statistics.activeCustomers;*/
    });
  }

  onCustomerProductsLoaded(customerProductsList) {
    this.model.balance.available = customerProductsList.balance;
  }

  refreshBalance() {
    this.updateModel().then(() => this.broadcast('reload.customer-products'));
  }

  checkStatus() {
    this.DashboardStore.getCondition()
    .then((response) => {
      let showModal = this.StorageService.getItem('show_activation_modal');
      if (parseBoolean(showModal) && response.user.activation_code) {
        if (response.user.activation_timestamp == response.user.activation_sent_timestamp) {
          $('#welcome-modal').show();
          this.isEnabled = false;
        }
      }
    });
  }
}

export default DashboardController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/dashboard/dashboard.controller.js